var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 9.33301H21.3307",
    stroke: "#E26E6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 14.667H15.9974",
    stroke: "#E26E6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3359 28.667V28.0003C17.3359 24.2291 17.3359 22.3435 18.5075 21.1719C19.6791 20.0003 21.5647 20.0003 25.3359 20.0003H26.0026M26.6693 17.7911V13.3337C26.6693 8.30534 26.6693 5.79119 25.1071 4.22909C23.5451 2.66699 21.0309 2.66699 16.0026 2.66699C10.9743 2.66699 8.46014 2.66699 6.89803 4.22909C5.33594 5.79118 5.33594 8.30534 5.33594 13.3337V19.3926C5.33594 23.7193 5.33594 25.8826 6.51736 27.3479C6.75604 27.6439 7.02568 27.9135 7.32171 28.1522C8.78702 29.3337 10.9504 29.3337 15.277 29.3337C16.2178 29.3337 16.6881 29.3337 17.1189 29.1817C17.2085 29.1501 17.2962 29.1137 17.3819 29.0727C17.7941 28.8755 18.1266 28.543 18.7918 27.8778L25.1071 21.5625C25.8779 20.7917 26.2633 20.4063 26.4663 19.9162C26.6693 19.4262 26.6693 18.8811 26.6693 17.7911Z",
    stroke: "#E26E6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile01);
export default __webpack_public_path__ + "static/media/file-01.226648da1c7bacac2cbef3b78e780a51.svg";
export { ForwardRef as ReactComponent };